import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export function ErrorState({ message, onRetry }) {
  return (
    <Card data-testid="error-state" className="error-card">
      <CardContent className="error-content">
        <AlertTriangle className="h-5 w-5" />
        <span>{message}</span>
        {onRetry && <Button data-testid="error-retry-button" variant="outline" onClick={onRetry}>Reintentar</Button>}
      </CardContent>
    </Card>
  );
}
